// components
import { DialogActions, DialogActionsProps, styled } from '@mui/material';

export const StyledFlexMatchSettingsDialogActions = styled(
  DialogActions
)<DialogActionsProps>(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  right: 0,
  left: 0,
  background: theme.palette.background.paper,
  borderTop: `1px solid ${theme.palette.divider}`,

  '&&.MuiDialogActions-root': {
    padding: theme.spacing(4, 6)
  }
}));
